import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useWallet } from '../hooks/useWallet';

function BuyCrypto() {
  const navigate = useNavigate();
  const { wallet } = useWallet();
  // Only allow Solana USDC, auto fiat detection, prefill wallet if available
  const solanaAddress = wallet?.address || '';
  const iframeUrl = "https://buy.onramper.com?apiKey=pk_test_01JYP7VFRAZBE102M4V8DYM0R6&mode=buy&txnAmount=50000txnFiat=NGN&txnCrypto=USDC";

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="flex items-center mb-6">
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center text-blue-500 hover:text-blue-700 mr-4"
        >
          <FiArrowLeft className="mr-2" /> Back
        </button>
        <h1 className="text-2xl font-bold">Buy Crypto</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex justify-center">
          <iframe        
            src={iframeUrl}
            title="Onramper Widget"
            height="630px"
            width="420px"
            allow="accelerometer; autoplay; camera; gyroscope; payment; microphone"
            className="rounded-lg border border-gray-200"
          />
        </div>
      </div>
    </div>
  );
}

export default BuyCrypto;
